// extracted by mini-css-extract-plugin
export var section = "styles-module--section--20twI";
export var title = "styles-module--title--2zguq";
export var container = "styles-module--container--ZCRrk";
export var image = "styles-module--image--1yEir";
export var imgContainer = "styles-module--imgContainer--1m0QB";